import { Domain as AuthDomain } from 'auth-common/domain';
import type { Tagged } from 'type-fest';
import { SystemMutableEntity as SME } from '../../common';
import { UniqueShortId } from '../../common/id';
import { Identifier } from '../../common/identifier';

import Project = AuthDomain.Object.Project;

import type { SystemCommandContext } from '../common';

const uuidGenerator = UniqueShortId.GetFactory(21);

export type IdentityNode = SME & {
  id: IdentityNode.Id;
  projectId: Project.Id;
  identifier: Identifier;
};

export namespace IdentityNode {
  export type Id = Tagged<UniqueShortId, 'identityNodeId'>;
  export namespace Id {
    export const Generate = () => uuidGenerator.generate() as Id;
    export function FromString(id: string): Id {
      return uuidGenerator.FromString(id) as Id;
    }
  }

  export type Props = {
    id: string;
    projectId: string;
    identifier: Identifier.Props;
  } & SME.Props;

  export const Construct = (props: Props): IdentityNode => {
    return {
      id: Id.FromString(props.id),
      projectId: Project.Id.FromString(props.projectId),
      identifier: Identifier.Construct(props.identifier),
      ...SME.Construct(props),
    };
  };

  export namespace Create {
    export type Props = Omit<IdentityNode.Props, 'id' | 'projectId' | 'createdAt' | 'updatedAt'>;
    export type Params = {
      context: SystemCommandContext;
      props: Create.Props;
    };
  }
  export const Create = (params: Create.Params): IdentityNode => {
    const { context, props } = params;
    const { projectId, now } = context;
    return Construct({
      id: Id.Generate(),
      projectId,
      ...props,
      ...SME.Create({ date: now }),
    });
  };
}
